import React from 'react'
import image1 from '../assets/images/bear-hungry.gif'
import '../assets/css/loading.css'

export default function Loading() {
  return (
    <>
    <div className='LoadingImageGif'>
      <img src={image1}></img>
      <div className='LoadingText'>Patience, my culinary explorer! We're stirring up something delightful for you. In the meantime, how about practicing your air drumming skills? A good meal and a drum solo make a perfect duet!</div>
    </div>
    </>
  )
}
